import React, {useEffect} from "react";
import styles from "./UeberUns.module.css";
import unserteam from './assets/karriere_foto.png';
import philosophie from './assets/11062b_95c05085f74d4a44842ef9b5285e5c12~mv2.avif';
import geschichte from './assets/11062b_3acc413de3044ad3bef273e7fc2b0661~mv2.avif';
import SubMenu from "../base/SubMenu";
import Geschichte from "./Geschichte";
import Philosophie from "./Philosophie";
import Karriere from "../karriere/Karriere";
import {useSearchParams} from "react-router-dom";



export const HomeCatcher = () => {
    const academicData = [
        {
            img: philosophie,
            title: "Philosophie",
            description: "Unsere Philosophie stellt den Menschen in den Mittelpunkt.",
            link: "/uberuns?scrollIntoView=philosophie"
        },
        {
            img: geschichte,
            title: "Geschichte",
            description: "Unsere Geschichte prägt unsere Werte und Vision.",
            link: "/uberuns?scrollIntoView=geschichte"
        },

        {
            img: unserteam,
            title: "Karriere",
            description: "Gemeinsam wachsen und Zukunft gestalten.",
            link: "/karriere?scrollIntoView=karriere"
        },
    ];

    return (
        <div className={styles.homeCatcherWrapper}>
            <div className={styles.inner}>
                <h1 className={styles.title}>Über Uns</h1>
                <div className={styles.grid}>
                    {academicData.map((card, index) => (
                        <div
                            key={index}
                            className={styles.card}
                            onClick={() => window.location.href = card.link}
                            style={{ backgroundImage: `url(${card.img})` }}
                        >
                            <div className={styles.overlay}>
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                                <button
                                    className={styles.readMore}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.location.href = card.link;
                                    }}
                                >
                                    Weiterlesen
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};


export const Main = (props) => {

    const geschichteRef = React.createRef()
    const philosophieRef = React.createRef()
    const karriereRef = React.createRef()

    const [searchParams, setSearchParams] = useSearchParams();
    const [activeSection, setActiveSection] = React.useState('');


    useEffect(() => {
        let scrollIntoViewValue = searchParams.get('scrollIntoView')
        if(scrollIntoViewValue === 'geschichte'){
            geschichteRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'philosophie'){
            philosophieRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'karriere'){
            karriereRef.current.scrollIntoView()
        }

    },[searchParams]);


    return(
        <React.Fragment>

            <React.Fragment>
               <SubMenu model={{
                   background: "rgb(38, 193, 101)",
                   items: [
                          {
                              label: "PHILOSOPHIE",
                              onClick: () => {
                                  philosophieRef.current.scrollIntoView();
                              },
                          },
                          {
                              label: "GESCHICHTE",
                             onClick: () => {
                                const offset = 0;
                                const element = geschichteRef.current;
                                const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
                                window.scrollTo({ top: y, behavior: 'smooth' });
                         },
                          },
                          {
                              label: "KARRIERE",
                            onClick: () => {
                                   const offset = 50;
                                   const element = karriereRef.current;
                                   const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
                                   window.scrollTo({ top: y, behavior: 'smooth' });
                                }
                                }


                      ]
               }} />

                <div ref= {philosophieRef}><Philosophie/></div>
                <div ref= {geschichteRef} style={{paddingTop: 'calc(var(--header-height))'}}><Geschichte/></div>
                <div ref= {karriereRef} style={{paddingTop: 'calc(var(--header-height))'}}><Karriere/></div>

            </React.Fragment>



        </React.Fragment>
    );
};

export default Main;
